<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div style="position:relative;">
      <img class="shousu" v-if="!isshow" src="@/assets/img/dataImport/xia-down.png" alt="" @click="shousu()" srcset="">
      <div class="topFlex" v-if="!isshow">
        <div>
        <span class="label">名称：</span>
        <span>202001工资</span>
      </div>
        <div>
          <span class="label">工资月份：</span>
          <span>2020-01</span>
        </div>
        <div>
        <span class="label">社保月份：</span>
          <span>2020-01</span>
      </div>
        <div>
          <span class="label">税金月份：</span>
          <span>2020-01</span>
        </div>
        <div>
          <span class="label">工资表模板：</span>
          <span>工资补贴模板</span>
        </div>
        <div>
          <span class="label">薪酬组：</span>
          <span>华中区人员薪酬组</span>
        </div>
      </div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" v-if="isshow">
        <div >
          <el-form-item label="服务组合：">
            <el-select v-model="formInline.region" style="width: 250px;margin-right: 15px;" placeholder="活动区域">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
					 <el-tooltip class="item" effect="light" :content="content" placement="right" style="margin-right: 30px;margin-top: 4px;" >
						<img src="@/assets/img/dataImport/yiwen.png" alt="">
					</el-tooltip>
					
          <el-form-item label="薪酬组：">
            <el-select v-model="formInline.region" style="width: 250px;margin-right: 30px;" placeholder="活动区域">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工资表：">
            <el-select v-model="formInline.region" style="width: 250px;" placeholder="活动区域">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="名称：">
            <el-input v-model="formInline.input" placeholder="请输入内容" style="width: 142px;margin-right: 80px;"></el-input>
          </el-form-item>
          <el-form-item label="工资月份：">
            <el-date-picker
						 style="width: 142px;margin-right: 80px;"
              v-model="formInline.value1"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="社保月份：">
            <el-date-picker
						style="width: 142px;margin-right: 80px;"
              v-model="formInline.value1"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="积金月份：">
            <el-date-picker
						style="width: 142px;margin-right: 80px;"
              v-model="formInline.value1"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>

        </div>
       </el-form>
      <div style="margin-top: 10px;background:#fff;padding:0 20px;">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="数据导入" name="first">
              <div class="steps">
                  <div :class="{'active':active=='step1'}" @click="activeDiv('step1')">
                      <div>
                          <span>1</span>
                          <h3>数据导入</h3>
                        <p>收集薪资相关数据并上传</p>
                      </div>
                  </div>
                <div @click="activeDiv('step2')" :class="{'active':active=='step2'}">
                  <div>
                    <span>2</span>
                    <h3>表头匹配</h3>
                    <p>匹配上传文件的表头与系统字段</p>
                  </div>
                </div>
                <div @click="activeDiv('step3')" :class="{'active':active=='step3'}">
                  <div>
                    <span>3</span>
                    <h3>数据校验</h3>
                    <p>校验上传数据并反馈错需信息</p>
                  </div>
                </div>
                <div @click="activeDiv('step4')" :class="{'active':active=='step4'}">
                  <div>
                    <span>4</span>
                    <h3>导入完成</h3>
                    <p>导入完成并计算上传雇员的薪资数据</p>
                  </div>
                </div>
              </div>
           <div class="line"></div>
					 <keep-alive>
							<component v-bind:is="active" :step.sync="active" style="width: 100%;"></component>
						</keep-alive>
       

          
          </el-tab-pane>
          <el-tab-pane label="复制历史数据" name="second">
            <dataHistory></dataHistory>
          </el-tab-pane>
        </el-tabs>
      </div>

    </div>
</template>

<script>
  import dataHistory from "@/views/demo/dataImport/template/dataHistory.vue"
	import step1 from "@/views/demo/dataImport/template/step1.vue"
	import step2 from "@/views/demo/dataImport/template/step2.vue"
	import step3 from "@/views/demo/dataImport/template/step3.vue"
	import step4 from "@/views/demo/dataImport/template/step4.vue"
  export default {
    name: "dataImport",
    components: {
      dataHistory,
			step1,
			step2,
			step3,
			step4
    },
    data() {
      return {
        active:'step2',
        isshow:false,
        activeName: 'second',
       content:'数据准备 > 数据准备 > 数据准备',
        formInline: {
          value1: '',
          region: '',
          input:''
        }
      }
    },
		mounted() {
		window.addEventListener('scroll', this.handleScroll,true);
		},
  methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      },
			handleScroll(){
				this.isshow = false;
			},
      shousu(){
        this.isshow = !this.isshow;
      },
      activeDiv(i){
        this.active = i;
      }
    }
  };
</script>

<style scoped>
  .flex{
    display: flex;
  }
  .topFlex{
    display: flex;
    justify-content: space-between;
    background: #fff;
    padding: 18px 90px 18px 20px
  }
  .el-form {
    padding:20px 0 4px 20px;
    background:#fff;
  }
  .el-form--inline .el-form-item{
    margin-bottom:16px;
  }
  .el-form .topFlex{
    padding:0;
  }
  .el-tabs__content{
    background: #fff;
  }
  .topFlex span{
    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:20px;
  }
  .topFlex .label{
    font-size:14px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:20px;
  }

  .steps{
        padding: 34px 166px 24px;
    display: flex;
  }
  .steps>div{
      width: 25%;
    text-align: center;
    position: relative;
  }
  .steps>div:before{
    content: '';
    position: absolute;
    width: 100%;
    height: 2px;
    background: #C6CEDF;
    left: 0;
    top: 15px;
  }
  .steps>div span{
    display: inline-block;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background:rgba(66,106,198,1);
    text-align: center;
    line-height: 30px;
    color: #fff;
    font-size: 13px;
    margin-bottom: 33px;
    position: relative;
    z-index: 10;
    cursor: pointer;
  }
  .steps>div h3{
    color:rgba(66,106,198,1);
    font-size: 13px;
    font-weight: 500;
    margin-bottom: 4px;
  }
  .steps>div p{
    font-size:12px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(66,106,198,1);
  }

 
  .steps .active ~ div span{
    background: #C3CCE1;
  }
  .steps>div.active~ div h3,.steps>div.active~ div p{
    color: #9CACC9;
  }

 
 
  .light-theme #main > div:not(.home){
    background: none;
    padding: 0;
  }
  .shousu{
    position: absolute;
    top: 20px;
    right: 26px;
    cursor: pointer;
  }
  .line{
    height:5px;
    width:calc(100% - 168px);
		margin: 0 auto;
		background:rgba(238,238,238,1);
		border-radius: 50%;
  }
</style>
